export const groupAccessTypes = Object.freeze({
  OPEN: 'open',
  CLOSED: 'closed',
  APPLICATION: 'application',
});
